function callAll(jsfiles) {
    var src = document.createElement("script");
    src.setAttribute("type", "text/javascript");
    src.setAttribute("src", jsfiles);
    document.getElementsByTagName("head")[0].appendChild(src);
}

function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

var first = getUrlVars()["contact%5Btags%5D"];
// To get the second parameter
var second = getUrlVars()["form_type"];

function onLoadCall(a,b){
  if(first==='newsletter' && second==="customer"){
 
    $('.Footer__Newsletter.Form').after('<p class="showSeconds">Please check your Email, we have sent a coupon code.</p>');
  }
}


setTimeout(function(){

  onLoadCall(first,second);
},500);


// callAll('https://cdn.shopify.com/s/files/1/0050/5135/1128/t/22/assets/lazysizes.min.js?v=17435836340443258698');
// callAll('https://cdn.shopify.com/s/javascripts/currencies.js');
// callAll('https://ajax.googleapis.com/ajax/libs/jquery/3.5.1/jquery.min.js');
// callAll('https://cdn.shopify.com/s/files/1/0050/5135/1128/t/22/assets/jquery_accordion.js?v=6470941146158954300');
// callAll('https://cdn.shopify.com/s/files/1/0050/5135/1128/t/22/assets/libs.min.js?v=8846682211898979100');
// callAll('https://cdn.shopify.com/s/files/1/0050/5135/1128/t/22/assets/theme.min.js?v=1038699858865521634');

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

setTimeout(function(){

  $(window).scroll(function(){
  var wh = $(window).height()-50;
  var bg = $('#blackBackgroundSection7');
    if (bg.length) {
      var contentBG = bg.offset().top;
       console.log(wh)
        if($(window).scrollTop() > contentBG - wh){
        $('#blackBackgroundSection7').addClass('animate__animated animate__bounce');
      }

    }

    });

if ($('body').hasClass('template-product') !== true) {
   $('a').each(function(){
     var href = $(this).attr('href');
     if(href.indexOf("?") > -1) href = href + "&";
     else href = href + "?";
     href = href + "utm_source=nutrav.com&utm_medium=nutrav.com&utm_campaign=nutrav";
     $(this).attr('href',href); 
   });
}
$('.accordion').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav'
  });
  
//   $( "#accordionExample" ).accordion();
//    $(document).ready(function(){
        // Add down arrow icon for collapse element which is open by default
        $(".collapse.show").each(function(){
        	$(this).prev(".card-header").find(".fa").addClass("fa-angle-down").removeClass("fa-angle-right");
        });
        
        // Toggle right and down arrow icon on show hide of collapse element
        $(".collapse").on('show.bs.collapse', function(){
        	$(this).prev(".card-header").find(".fa").removeClass("fa-angle-right").addClass("fa-angle-down");
        }).on('hide.bs.collapse', function(){
        	$(this).prev(".card-header").find(".fa").removeClass("fa-angle-down").addClass("fa-angle-right");
        });
//     });


$(".hover_bkgr_fricc").css("display","none");
$(".trigger_popup_fricc1").click(function(e){
  e.preventDefault();
  $('.PageOverlay').addClass('pop');
  $('html').addClass('no-scroll');
  setTimeout(function(){
    $('.hover_bkgr_fricc').css('opacity',1);
    $('.hover_bkgr_fricc').show();
    $('.view_cart_continues').show();
    $('.view_shopping_continues').show();
    $('.cartcheckout').show();
    $('.html-content').show();
    $('.items_count').show();
  },1000);
  $('.Drawer.Drawer--fromRight').hide();

  addcart_final();


});

$('.PageOverlay').removeClass('pop');

$('.hover_bkgr_fricc').click(function(e){
  if (!$(e.target).closest('.custom-size-img').length) {
    $(".hover_bkgr_fricc").css("display","none");
    //$('.Drawer.Drawer--fromRight ').hide();
    $('html').removeClass('no-scroll');

  };
  //$('.Drawer.Drawer--fromRight ').hide();
  $('.PageOverlay').addClass('pop');
  $('html').removeClass('no-scroll');

});

$('.popupCloseButton').click(function(){
  $('.hover_bkgr_fricc').hide();
  $('html').removeClass('no-scroll');
});

function addcart_final(id,quantity){
  var val1= $('input.qty').val();
  var variant = $('.ProductForm__Variants input').val();
  data= {
    quantity: val1 ,
    id: variant,
  }
  $.ajax({
    type:'POST',
    url:'/cart/add.js',
    data : data,
    dataType: 'json',
    //async: false,
    success: function(data) { 
      $.ajax({
        type: 'GET',
        url: '/cart',
        dataType: "html",
        success: function (data) {
          // console.log(data);
          var item_image=$(data).find('.CartItem__ImageWrapper').html();
          var item_title=$(data).find('.CartItem__Title.Heading').html();
          var item_price=$(data).find('.CartItem__LinePriceList ').html();
          var item_counts=$(data).find('span.Header__CartCount').text();

          //console.log("data" + newhtml);
          $('.cart_image').html(item_image);
          $('.heading_title').html(item_title);
          $('.total_price').html(item_price);
          $('span.countss').html(item_counts);


        },
        failure: function (data) {
          alert('Not Response');
        }
      });
      // alert(data);
    } 

  });    
}
$(document).on('click', '.Cart__Checkouts', function(){

  $( ".Cart__Checkout" ).trigger( "click");

});




$(document).ready(function(){
  setTimeout(function(){
    $('.SRI-widget input[type="radio"]:checked').parents('label').addClass('border_select');
    $('.SRI-widget label').change(function(){
      $('.border_select').removeClass('border_select');
      $(this).addClass('border_select');
    });
  },5500);

});
//ajax search
$(document).ready(function(){
  var searchForms = $('.search-filter-desktop').find('form[action="/search"]');
  var input = $('.search-filter-desktop').find('input[name="q"]');

  input.attr('autocomplete', 'off').bind('keyup change', function() {
    var term = $(this).val();
    var form = $(this).closest('form');
    var searchURL = '/search?type=product&q=' + term;
    var resultsList = $(this).parents('.search-filter-desktop').find('.ssm_products');
    var resultsWrapper = $(this).parents('.search-filter-desktop').find('.ssm_results');
    var viewall = $(this).parents('.search-filter-desktop').find('.ssm_viewall');

    viewall.find('span').text(term);
    viewall.find('a').attr('href', searchURL);

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": "product",
        "limit": 8,
        "options": {
          "unavailable_products": "last",
          "fields": "title,product_type,variants.title,body,tag"
        }
      }
    }).done(function(response) {
      var products = response.resources.results.products;
      console.log(products);
      if (products.length > 0) {
        resultsList.empty();
        $.each(products, function(index, item) {
          var link = $('<a></a>').attr('href', item.url);
          link.append('<span class="thumbnail"><img src="' + item.featured_image .url + '" /></span>');
          link.append('<span class="title">' + item.title + '</span>');
          link.wrap('<li></li>');
          resultsList.append(link.parent());
        });

        resultsWrapper.fadeIn();
        resultsWrapper.parents('.search-filter-desktop').addClass('ssm_search_open');
      }
      else{
        resultsWrapper.hide();
        resultsWrapper.parents('.search-filter-desktop').removeClass('ssm_search_open');
      }
    });
    if(term == ''){
      resultsWrapper.hide();
      resultsWrapper.parents('.search-filter-desktop').removeClass('ssm_search_open');
    }
  });

  $(document).click(function (e) {
    if (!$(e.target).closest('.search-filter-desktop').length) {
      $('.ssm_results').hide();
      $('.search-filter-desktop').removeClass('ssm_search_open');

    }
  });



  $('footer a[href="/search"]').click(function(e){
    e.preventDefault();
    $('html,body').animate({scrollTop:0},0);
    var input = $('.search-filter-desktop').find('input[name="q"]');
    input.attr('autocomplete', 'off').focus(); 
  });
  //review scrolling
  $(document).on('click', '.ProductItem span.stamped-starrating.stamped-badge-starrating i', function(e){
    e.preventDefault();
    var url=$(this).parents('.stamped-product-reviews-badge').attr('data-url');
    console.log(url);
    window.location.href = url+'?review=true';


  });

  if (window.location.href.indexOf("?review=true") > -1) {
    setTimeout(function(){
      $('html, body').animate({
        scrollTop: $('#stamped-main-widget').offset().top
      }, 'slow');
    },2000);
  }
  setTimeout(function(){
    jQuery(document).on('qodeAjaxPageLoad', function () {
      if (typeof StarRating !== 'function') return;
      new StarRating( 'stamped-product-reviews-badge.stamped-main-badge', {
        clearable: false,
        showText: false,
      });
    });
  },2000);
  //location show
  jQuery.getJSON('https://ipapi.co/json', function(location) {

    var mycountry = location.country_name;
    if(mycountry){
      $('.get__location span.country_name').text(mycountry);
      $('.get__location').show();
    }
  });
  //product tooltip
  $('.tooltip').click(function(){
    $('.tooltiptext').toggle();

  });

  document.addEventListener('product:added', function(event) {
    setTimeout(function(){
      $('.crt_add_msg').show();
    }, 800);
  });

});
$(document).ready(function() {
  $('ul.tabs').each(function(){
    var active, content, links = $(this).find('a');
    active = links.first().addClass('active');
    content = $(active.attr('href'));
    links.not(':first').each(function () {
      $($(this).attr('href')).hide();
    });
    $(this).find('a').click(function(e){
      active.removeClass('active');
      content.hide();
      active = $(this);
      content = $($(this).attr('href'));
      active.addClass('active');
      content.show();
      return false;
    });
  });
  if($('.Product__Benefits-Icons').length > 0){
    $('.Product__Benefits-Icons_jk-active').append($('.Product__Benefits-Icons').html());
  }
  $(".guarantee_popup").css("display","none");
  $(".product__tab1").click(function(){
    $('.guarantee_popup').css('opacity',1);
    $('.guarantee_popup').fadeIn();
  });
  $('.guarantee_popup').click(function(e){
    if (!$(e.target).closest('.custom-size-img1').length) {
      $(".guarantee_popup").fadeOut();
    };
  });
  $('.popupCloseButton1').click(function(){
    $('.guarantee_popup').fadeOut();
  });


  $(".shipping_popup").css("display","none");
  $(".product__tab2").click(function(){
    $('.shipping_popup').css('opacity',1);
    $('.shipping_popup').fadeIn();
  });
  $('.shipping_popup').click(function(e){
    if (!$(e.target).closest('.custom-size-img_1').length) {
      $(".shipping_popup").fadeOut();
    };
  });
  $('.popupCloseButton_1').click(function(){
    $('.shipping_popup').fadeOut();
  });

  
});
//Mobile search scroll

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();

  //>=, not <=
  if (scroll > 80) {
    //clearHeader, not clearheader - caps H
    $(".mobile__search ").addClass("darkHeader");
  }
  else
  {
    $(".mobile__search ").removeClass("darkHeader");
  }
});
//mobile add to cart trigger
$(document).on('click', '.trigger_mobile .trigger__cart', function(){

  $( ".ProductForm__AddToCart" ).trigger( "click");

});
$(document).on('click', '.button_add_third', function(){

  $( ".trigger_popup_fricc" ).trigger( "click");

});
document.addEventListener("DOMContentLoaded", function() {
  var lazyloadImages = document.querySelectorAll("img.lazy");    
  var lazyloadThrottleTimeout;
  
  function lazyload () {
    if(lazyloadThrottleTimeout) {
      clearTimeout(lazyloadThrottleTimeout);
    }    
    
    lazyloadThrottleTimeout = setTimeout(function() {
        var scrollTop = window.pageYOffset;
        lazyloadImages.forEach(function(img) {
            if(img.offsetTop < (window.innerHeight + scrollTop)) {
              img.src = img.dataset.src;
              img.classList.remove('lazy');
            }
        });
        if(lazyloadImages.length == 0) { 
          document.removeEventListener("scroll", lazyload);
          window.removeEventListener("resize", lazyload);
          window.removeEventListener("orientationChange", lazyload);
        }
    }, 20);
  }
  
  document.addEventListener("scroll", lazyload);
  window.addEventListener("resize", lazyload);
  window.addEventListener("orientationChange", lazyload);
});
  
}, 100);


